'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _utils = require('../../utils');

var _constants = require('../../constants');

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var truncate = _utils.FormattingUtils.truncate,
    formatMoney = _utils.FormattingUtils.formatMoney;
var ACTIVITY_TRUNCATE_LENGTH = _constants.AppConstants.ACTIVITY_TRUNCATE_LENGTH,
    CRUD = _constants.AppConstants.CRUD;

var LienReturnAction = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(LienReturnAction, _Component);

  function LienReturnAction() {
    _classCallCheck(this, LienReturnAction);

    return _possibleConstructorReturn(this, (LienReturnAction.__proto__ || Object.getPrototypeOf(LienReturnAction)).apply(this, arguments));
  }

  _createClass(LienReturnAction, [{
    key: 'render',
    value: function render() {
      var _actionBodies;

      var _props$activity = this.props.activity,
          action = _props$activity.action,
          actual_amount = _props$activity.actual_amount,
          actualAmount = formatMoney(actual_amount),
          actionBodies = (_actionBodies = {}, _defineProperty(_actionBodies, CRUD.CREATE, 'Logged payment for ' + actualAmount + '.'), _defineProperty(_actionBodies, CRUD.DELETE, 'Deleted payment for ' + actualAmount + '.'), _actionBodies),
          body = actionBodies[action].replace('  ', ' '),
          truncatedBody = truncate(body, ACTIVITY_TRUNCATE_LENGTH);


      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: body,
        dot: 'icon',
        icon: 'usd',
        truncatedBody: truncatedBody
      }, this.props));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LienReturnAction;
}(_react.Component), _class2.propTypes = {
  activity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired
}, _temp)) || _class) || _class;

var _default = LienReturnAction;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(truncate, 'truncate', '/app/src/components/common-activities/LienReturnAction.js');
  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/common-activities/LienReturnAction.js');
  reactHotLoader.register(ACTIVITY_TRUNCATE_LENGTH, 'ACTIVITY_TRUNCATE_LENGTH', '/app/src/components/common-activities/LienReturnAction.js');
  reactHotLoader.register(CRUD, 'CRUD', '/app/src/components/common-activities/LienReturnAction.js');
  reactHotLoader.register(LienReturnAction, 'LienReturnAction', '/app/src/components/common-activities/LienReturnAction.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/LienReturnAction.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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